export default __webpack_public_path__ + "static/media/close_toast_black.1330f66c.svg";